export enum OfferTypeEnum {
  physical = 'physical',
  digital = 'digital',
}
